/*
 * Breadcrumb label registry.
 *
 * One entry per route declared in App.js. Paths use the same syntax as the
 * <Route path> they mirror, and are matched with react-router's own matchPath
 * so params work without any URL string-parsing.
 *
 * Pages whose crumb depends on their data (an article, an issue, a paper)
 * override this at render time with the useBreadcrumbLabel hook.
 * Anything missing here falls back to a title-cased last path segment, so a
 * new route is never blank.
 */
export const routeTitles = [
    { path: '/', label: 'Home' },
    { path: '/about', label: 'About' },
    { path: '/krmangalam-university', label: 'K.R. Mangalam University' },
    { path: '/developers', label: 'Developer Team' },
    { path: '/contact', label: 'Contact' },
    { path: '/abstracting-indexing', label: 'Abstracting & Indexing' },
    { path: '/editorial-leadership', label: 'Editorial Leadership' },
    { path: '/editorial-board', label: 'Editorial Leadership' },
    { path: '/reviewers', label: 'Reviewers' },
    { path: '/author-guidelines', label: 'Author Guidelines' },
    { path: '/author-guidelines/latex-template', label: 'LaTeX Template' },
    { path: '/privacy-policy', label: 'Privacy Policy' },
    { path: '/terms-and-conditions', label: 'Terms & Conditions' },
    { path: '/ethics', label: 'Ethics' },
    { path: '/itme-policies-framework', label: 'ITME Policies' },

    // Publications
    { path: '/archives', label: 'Archives' },
    { path: '/archives/vol/:volumeId/iss/:issueId/art/:articleId', label: 'Article' },
    { path: '/archives/:quarter/:volumeNumber', label: 'Volume' },
    { path: '/current-issue', label: 'Current Issue' },

    // Auth
    { path: '/login', label: 'Login' },
    { path: '/signup', label: 'Sign Up' },
    { path: '/forgot-password', label: 'Forgot Password' },

    // Authenticated areas
    { path: '/dashboard', label: 'Dashboard' },
    { path: '/profile', label: 'Profile' },
    { path: '/form', label: 'Submit Manuscript' },
    { path: '/admin', label: 'Admin' },
    { path: '/view/:paperId', label: 'Paper' },
    { path: '/reviewer/dashboard', label: 'Reviewer Dashboard' },
    { path: '/reviewer/page/:id', label: 'Reviewer' },
    { path: '/reviewer/invite/:inviteid', label: 'Reviewer Invitation' },
];
